import { CatalogItemType } from '@pushly/models/lib/enums'
import { DomainDto } from '../../../dtos/domain'

/**
 * Returns the default catalog item type for the domain.
 * Falls back to Product when domain.ecommConfig.itemType is undefined.
 */
export function getDefaultCatalogItemType(domain: DomainDto | undefined): CatalogItemType {
    return domain?.ecommConfig?.itemType ?? CatalogItemType.PRODUCT
}

/**
 * Returns the default max abandoned item age (in days) for the domain.
 * Falls back to 30 when domain.ecommConfig.maxAbandonedItemAgeDays is undefined.
 */
export function getDefaultMaxAbandonedItemAgeDays(domain: DomainDto | undefined): number {
    return domain?.ecommConfig?.maxAbandonedItemAgeDays ?? 30
}
